import rebate from './rebate'

export default {
	rebate
}
